function getCartItemCount(callback) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      callback(data.item_count); // Pass the value to your callback
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      callback(0); // fallback in case of error
    });
}




function ChangeCartBubble(cartItemCount) {
    // debugger;
 
  const bubbleDivs = document.querySelectorAll(".cart-count-bubble");
  if (bubbleDivs.length === 0) {
    const bubbleDiv = document.createElement('div');
    bubbleDiv.className = 'cart-count-bubble';
    
    // Create <span aria-hidden="true">10</span>
    const visibleSpan = document.createElement('span');
    visibleSpan.setAttribute('aria-hidden', 'true');
    visibleSpan.textContent = `${cartItemCount}`;

    // Create <span class="visually-hidden">10 items</span>
    const hiddenSpan = document.createElement('span');
    hiddenSpan.className = 'visually-hidden';
    hiddenSpan.textContent = `${cartItemCount} items`;

    // Append spans to div
    if(cartItemCount < 1000){
    bubbleDiv.appendChild(visibleSpan);
    }
    bubbleDiv.appendChild(hiddenSpan);

    // Append to all cart icon elements
    document.querySelectorAll(".header__icon.header__icon--cart").forEach(cartIcon => {
      cartIcon.appendChild(bubbleDiv.cloneNode(true));
    });
  } else {
    bubbleDivs.forEach(bubbleDiv => {
      // Update existing spans inside each bubble
    const spans = bubbleDiv.querySelectorAll('span');

// Update existing spans
if (spans[0]) spans[0].textContent = `${cartItemCount}`;
if (spans[1]) spans[1].textContent = `${cartItemCount} item${cartItemCount === 1 ? '' : 's'}`;

// If count is over 1000, remove the visible span (based on your theme logic)
if (cartItemCount > 1000 && spans[0]) {
  spans[0].remove(); // Correct method to remove a DOM element
}

    })
      
    
  }
}


   // Helper function to hide all error messages
  function hideAllErrorMessages() {
    document.querySelectorAll(
      '.custom-product-form__error-message-wrapper, ' +
      '.custom-product-form__error-message-wrapper-main'
    ).forEach(wrapper => {
      wrapper.hidden = true;
      wrapper.style.display = 'none';
    });
  }

  // Helper function to show main error message
  function showMainErrorMessage(message) {
    const wrapper = document.querySelector('.custom-product-form__error-message-wrapper-main');
    const messageBox = document.querySelector('.custom-product-form__error-message-main');
    
    if (wrapper && messageBox) {
      wrapper.hidden = false;
      wrapper.style.display = 'flex';
      messageBox.textContent = message;
    }
  }

  // Helper function to show row-specific error message
  function showRowErrorMessage(row, message) {
    const wrapper = row.querySelector('.custom-product-form__error-message-wrapper');
    const messageBox = row.querySelector('.custom-product-form__error-message');

    if (wrapper && messageBox) {
      wrapper.hidden = false;
      wrapper.style.display = 'flex';
      messageBox.textContent = message;
    }
  }

  // Helper function to reset all quantity inputs to 0
  function resetQuantityInputs(form) {
    form.querySelectorAll('.product-row').forEach(row => {
      const quantityInput = row.querySelector('input[name="items[][quantity]"]');
      if (quantityInput) quantityInput.value = 0;
    });
  }

  // Helper function to collect valid items from the form
  function collectValidItems(form) {
    const items = [];
    
    form.querySelectorAll('.product-row').forEach(row => {
      const idInput = row.querySelector('input[name="items[][id]"]');
      const quantityInput = row.querySelector('input[name="items[][quantity]"]');

      if (!idInput || !quantityInput) return;

      const id = idInput.value;
      const quantity = parseInt(quantityInput.value, 10);

      if (id && quantity > 0) {
        items.push({ id: Number(id), quantity });
      }
    });
    
    return items;
  }

  // Helper function to update cart drawer
  async function updateCartDrawer() {
    try {
      const cartDrawerEl = document.querySelector("cart-drawer");
      if (cartDrawerEl) {
        cartDrawerEl.classList.add("active");
        if (cartDrawerEl.classList.contains('is-empty')) {
          cartDrawerEl.classList.remove('is-empty');
        }
      }

      const drawerResponse = await fetch('/?section_id=cart-drawer');
      const html = await drawerResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (currentDrawer && newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    } catch (drawerErr) {
      console.error('❌ Failed to update cart drawer:', drawerErr);
    }
  }

  // Helper function to update cart sections
  function updateCartSections(latestResponse) {
    const itemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    
    itemsElement.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || 
        document.getElementById(section.id);
      elementToReplace.innerHTML = itemsElement.getSectionInnerHTML(
        latestResponse.sections[section.section],
        section.selector
      );
    });
  }


    function initCustomFormScript() {
      // console.log("Added");
      
      // debugger;
    updateAllVariantQuantities();
  const addToCartForms = document.querySelectorAll("#mlv-custom-form");
    
  // Main form submission handler
  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
    
      event.preventDefault();
      hideAllErrorMessages();

      // Collect valid items from form
      const items = collectValidItems(form);

      // Check if any items were selected
      if (items.length === 0) {
        showMainErrorMessage("No valid items selected. Please add at least one product");
        return;
      }

      let latestResponse;
      
      // Process each item individually
      for (const item of items) {
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [item],
              sections_url: window.location.pathname,
              sections: ["cart-drawer", "cart-icon-bubble"],
            }),
          });
          
          const data = await response.json();
          latestResponse = data;

          // Handle error response from server
          if (data.status && data.message) {
            const row = document.querySelector(`.product-row[data-variant-id="${item.id}"]`);
            if (row) {
              showRowErrorMessage(row, data.message);
            }
              if(Number(data.status) === 422 && data.description == 'Cart Error') {
                
              }else{
                
            
            resetQuantityInputs(form);
            await updateCartDrawer();
       getCartItemCount(function(count) {
  // console.log("🛒 Total items in cart:", count);
  // You can now use `count` to update UI, etc.
  ChangeCartBubble(count); // example usage
});
              }
    

          
          }
        } catch (err) {
          console.error(`❌ Error adding item ${item.id}:`, err);
        }
      }

      // Update UI after all items processed
      if (latestResponse.status != 422) {
       
        await updateAllVariantQuantities();
        await updateCartDrawer();
         updateCartSections(latestResponse);
      }
      
      resetQuantityInputs(form);
    });
  });

    const form2 = document.querySelector("#mlv-custom-cart-form");
  if (!form2) return;

  form2.addEventListener('submit', async function(e) {
    e.preventDefault();
    hideAllErrorMessages();

    const items = collectValidItems(form2);
    if (items.length === 0) {
      showMainErrorMessage("No valid items selected. Please add at least one product");
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items,
          sections_url: window.location.pathname,
          sections: ["cart-drawer", "cart-icon-bubble"]
        })
      });

      if (!response.ok) throw new Error('Failed to add to cart');
      
      updateAllVariantQuantities();
      window.location.href = '/cart';
    } catch (error) {
      // console.error('❌ Error adding to cart:', error);
    }
  });
  // Initialize variant quantities
  updateAllVariantQuantities();
    }
document.addEventListener("DOMContentLoaded", () => {
  // Run once on initial load
  initCustomFormScript();

  function waitForFormAndInit() {
    const observer = new MutationObserver((mutations, obs) => {
      const form = document.querySelector('#mlv-custom-form , #mlv-custom-cart-form'); // change selector as needed
      if (form) {
        // console.log("✅ Form detected after URL change");
        initCustomFormScript();
        obs.disconnect(); // Stop observing
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function onUrlChange() {
    // console.log("📌 URL changed, watching for DOM updates...");
    waitForFormAndInit();
  }

  // Watch pushState and replaceState
  ['pushState', 'replaceState'].forEach((method) => {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      onUrlChange();
      return result;
    };
  });

  // Also handle back/forward buttons
  window.addEventListener('popstate', onUrlChange);
});
